// extracted by mini-css-extract-plugin
export default {"loading":"paginated_exceptions_list___loading___b8523ead","noItems":"paginated_exceptions_list___noItems___efdd0c69"};